export function formatValue(strategy, format, value, options) {
    if (value === null) {
        return 'N/A';
    }
    if (!format) {
        return String(value);
    }
    if (format === 'currency') {
        return strategy.formatCurrency(value, options);
    }
    if (format === 'percentage') {
        return strategy.formatPercentage(value, options);
    }
    return String(value);
}
//# sourceMappingURL=formatHelper.js.map